import { render, staticRenderFns } from "./BookingCustomerNew.vue?vue&type=template&id=e0a4b248&"
import script from "./BookingCustomerNew.vue?vue&type=script&lang=js&"
export * from "./BookingCustomerNew.vue?vue&type=script&lang=js&"
import style0 from "./BookingCustomerNew.vue?vue&type=style&index=0&id=e0a4b248&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports